import {
  RoadmapEventComment as Data,
  RoadmapEventCommentCollection as Collection,
} from '@/typings/api/RoadmapEventComment'
import { RoadmapEvent } from '@/typings/api/RoadmapEvent'

import { BaseApiAuth } from '@/api/BaseApiAuth'
import { BaseApiParams } from '@/typings/common'


interface RoadmapEventCommentsApiParams extends BaseApiParams {
  event_id: RoadmapEvent['id'];
}


export class RoadmapEventCommentsApi extends BaseApiAuth<Data, Collection, RoadmapEventCommentsApiParams> {
  protected readonly endpoint = 'publications/events/:event_id/comments';
}
